import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Paper, Button, Typography } from '@mui/material';
import axios from "../../../axios-order";
import classes from "./form16.module.css";
import { useHistory, useParams, useLocation } from 'react-router-dom';
import DownloadIcon from '@mui/icons-material/Download';
import EmailIcon from '@mui/icons-material/Email';
import BoxWrapper from "../../../components/ui/boxWrapper";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Checkbox,
  FormGroup,
  FormControlLabel
} from '@mui/material';
import { toast } from "react-toastify";
import { canWrite } from '../../../utils/privilegeUtils';

const Form16Table = () => {
  const { job_id } = useParams();
  const history = useHistory();
  const location = useLocation();
  const [logViewData, setLogViewData] = useState([]);
  const [businessEntityId, setBusinessEntityId] = useState(localStorage.getItem("business_entity_id"));
  const [emailDialogOpen, setEmailDialogOpen] = useState(false);
  const [selectedEmails, setSelectedEmails] = useState({});
  const [vendorEmails, setVendorEmails] = useState([]);
  const [panOfDeductee, setPanOfDeductee] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [refreshTime, setRefreshTime] = useState(null);
  const [formId, setFormId] = useState(null);
  useEffect(() => {
    const storedRefreshTime = localStorage.getItem(`refreshTime_${job_id}`);
    const navigationRefreshTime = location.state?.refreshTime;
    const latestRefreshTime = navigationRefreshTime || storedRefreshTime;

    if (latestRefreshTime) {
      setRefreshTime(parseInt(latestRefreshTime));
    }

    getJobDetails();
  }, [page, rowsPerPage, job_id]);

  const getJobDetails = () => {
    axios.get(`/form_16_get_api_poll_job/${businessEntityId}/${job_id}?page=${page + 1}&per_page=${rowsPerPage}`)
      .then((res) => {
        setLogViewData(res?.data?.records || []);
        setTotalCount(res?.data?.pagination?.total_count || 0);
      })
      .catch((err) => {
        console.error(err);
        toast.error("Error fetching job details", { autoClose: 2000 });
      });
  };

  const onEnvelope = (pan_of_deductee,id) => {
    setPanOfDeductee(pan_of_deductee);
    setFormId(id);
    setVendorEmails([]);

    axios.get(`/form_16_get_api_email/${businessEntityId}/${pan_of_deductee}`)
      .then((res) => {
        if (res.data.status && res.data.data) {
          setVendorEmails(res.data.data);
          const initialSelectedState = {};
          res.data.data.forEach(item => {
            initialSelectedState[item.vendor_email] = false;
          });
          setSelectedEmails(initialSelectedState);
          setEmailDialogOpen(true);
        } else {
          setEmailDialogOpen(true);
        }
      })
      .catch((err) => {
        console.error(err);
        setEmailDialogOpen(true);
      });
  };

  const downloadBase64File = (contentType, base64Data, fileName) => {
    const linkSource = `data:${contentType};base64,${base64Data}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  const pdfDownload = (id) => {
    const contentType = "application/pdf";
    const filename = `Form_16_${id}.pdf`;

    axios.get(`/form_16_get_api_downlaod/${businessEntityId}/${id}`)
      .then((res) => {
        const base64Data = res?.data?.records;
        if (base64Data && base64Data[0]?.base64_pdf) {
          downloadBase64File(contentType, base64Data[0].base64_pdf, filename);
        } else {
          toast.error("No PDF data available for download", { autoClose: 2000 });
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error("Error downloading PDF", { autoClose: 2000 });
      });
  };

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const sendSelectedEmails = () => {
    const emailsToSend = Object.keys(selectedEmails).filter(email => selectedEmails[email]);
    if (emailsToSend.length > 0) {
      const payload = {
        business_entity_id: businessEntityId,
        pan_of_deductee: panOfDeductee,
        vendor_emails: emailsToSend,
        form16_id:formId
      };

      axios.post('/form_16_report_email', payload)
        .then((res) => {
          if (res.data.status) {
            toast.success(res.data.message, { autoClose: 2000 });
          }
        })
        .catch((err) => {
          console.error('Error sending emails:', err);
          toast.error("Error sending emails", { autoClose: 2000 });
        })
        .finally(() => {
          setEmailDialogOpen(false);
        });
    } else {
      toast.error("Please select at least one email to send", { autoClose: 2000 });
      // setEmailDialogOpen(false);
    }
  };

  return (
    <div>
      <BoxWrapper
        boxTitle="Form 16/16A"
        enableAddButton={true}
        addButtonLabel={'BACK'}
        addButtonHandlerFn={() => history.goBack()}
      >
        {refreshTime && (
          <Typography variant="body2" style={{ marginBottom: '10px' }}>
            Last refreshed at: {new Date(refreshTime).toLocaleString()}
          </Typography>
        )}
        <TableContainer component={Paper} sx={{
          mb: 2, mt: 2, maxHeight: '50vh',
          overflow: 'auto',
        }}>
          <Table>
            <TableHead stickyHeader>
              <TableRow>
                <TableCell className={classes.tableHeader} style={{ fontFamily: "'Dosis'" }}>EMPLOYEE/VENDOR NAME</TableCell>
                <TableCell className={classes.tableHeader} style={{ fontFamily: "'Dosis'" }}>PAN</TableCell>
                <TableCell className={classes.tableHeader} style={{ fontFamily: "'Dosis'" }}>EMAIL ID</TableCell>
                <TableCell className={classes.tableHeader} style={{ fontFamily: "'Dosis'" }}>FORM TYPE</TableCell>
                <TableCell className={classes.tableHeader} style={{ fontFamily: "'Dosis'" }}>QUATER</TableCell>
                <TableCell className={classes.tableHeader} style={{ fontFamily: "'Dosis'" }}>ACTION</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {logViewData?.length > 0 ? (
                logViewData.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{row.vendor_name}</TableCell>
                    <TableCell>{row.pan_of_deductee}</TableCell>
                    <TableCell>{row.vendor_emails?.join(', ') || ''}</TableCell>
                    <TableCell>{row.form}</TableCell>
                    <TableCell>{row.quarter}</TableCell>
                    <TableCell>
                      <DownloadIcon onClick={() => pdfDownload(row.id)} style={{ cursor: 'pointer', marginRight: '8px' }} />
                      {canWrite("FORM 16/16A") && (
                      <EmailIcon onClick={() => onEnvelope(row.pan_of_deductee, row.id)} style={{ cursor: 'pointer' }} disabled={!row.emailId} />
                      )}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6}>No data available</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={totalCount}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50]}
        />
      </BoxWrapper>

      <Dialog
        open={emailDialogOpen}
        onClose={() => setEmailDialogOpen(false)}
        aria-labelledby="email-dialog-title"
      >
        <DialogTitle id="email-dialog-title">Send Email</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Select recipients to send Form 16:
          </DialogContentText>
          {vendorEmails.length === 0 ? (
            <DialogContentText color="textSecondary">No email found</DialogContentText>
          ) : (
            <FormGroup>
              {vendorEmails.map((item, index) => (
                <FormControlLabel
                  key={index}
                  control={
                    <Checkbox
                      checked={!!selectedEmails[item.vendor_email]}
                      onChange={(e) => {
                        setSelectedEmails({
                          ...selectedEmails,
                          [item.vendor_email]: e.target.checked
                        });
                      }}
                    />
                  }
                  label={item.vendor_email}
                />
              ))}
            </FormGroup>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEmailDialogOpen(false)} color="primary">
            Cancel
          </Button>
          {canWrite("FORM 16/16A") && (
          <Button
            onClick={sendSelectedEmails}
            color="primary"
            disabled={vendorEmails.length === 0}
          >
            Send
          </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Form16Table;